/* unplugin-vue-components disabled */import script from "./GeoStart.vue?vue&type=script&lang=ts&setup=true"
export * from "./GeoStart.vue?vue&type=script&lang=ts&setup=true"

import "./GeoStart.vue?vue&type=style&index=0&id=f65cfdf0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f65cfdf0"]])

export default __exports__